import React, { useState, useEffect, useRef } from 'react';
import { FaSearch, FaSync, FaFileExport, FaCalendar, FaChevronDown, FaChevronUp, FaTag, FaMoneyBillWave, FaStore, FaChartLine, FaBox, FaLayerGroup } from 'react-icons/fa';
import { MdClose } from 'react-icons/md';
import { FaSpinner } from 'react-icons/fa';

// ============================================
// STYLES
// ============================================
const styles = {
    container: {
        padding: '24px',
        maxWidth: '1600px',
        margin: '0 auto',
        fontFamily: 'Segoe UI, sans-serif'
    },
    statsGrid: {
        display: 'grid',
        gridTemplateColumns: 'repeat(4, 1fr)',
        gap: '16px',
        marginBottom: '24px'
    },
    statCard: {
        background: 'white',
        borderRadius: '12px',
        padding: '20px 24px',
        boxShadow: '0 2px 8px rgba(0,0,0,0.06)',
        border: '1px solid #f0f0f0',
        transition: 'all 0.3s ease'
    },
    statLabel: {
        fontSize: '13px',
        color: '#94a3b8',
        fontWeight: '500',
        marginBottom: '6px'
    },
    statValue: {
        fontSize: '28px',
        fontWeight: '700',
        color: '#1e293b'
    },
    statSub: {
        fontSize: '12px',
        color: '#94a3b8',
        marginTop: '4px'
    },
    filtersBar: {
        display: 'flex',
        alignItems: 'center',
        gap: '12px',
        background: 'white',
        padding: '12px 20px',
        borderRadius: '12px',
        boxShadow: '0 2px 8px rgba(0,0,0,0.06)',
        border: '1px solid #f0f0f0',
        marginBottom: '24px',
        flexWrap: 'wrap'
    },
    searchWrapper: {
        display: 'flex',
        alignItems: 'center',
        flex: '1',
        minWidth: '200px',
        background: '#f8fafc',
        borderRadius: '8px',
        padding: '0 12px',
        border: '1px solid #e2e8f0',
        transition: 'all 0.2s ease'
    },
    searchInput: {
        border: 'none',
        background: 'transparent',
        padding: '10px 8px',
        fontSize: '14px',
        outline: 'none',
        flex: '1',
        color: '#334155'
    },
    dateFilterBtn: {
        display: 'flex',
        alignItems: 'center',
        gap: '8px',
        padding: '10px 16px',
        background: '#f8fafc',
        border: '1px solid #e2e8f0',
        borderRadius: '8px',
        fontSize: '14px',
        color: '#334155',
        cursor: 'pointer',
        transition: 'all 0.2s ease',
        minWidth: '140px',
        whiteSpace: 'nowrap'
    },
    actionBtn: {
        display: 'flex',
        alignItems: 'center',
        gap: '6px',
        padding: '10px 18px',
        border: 'none',
        borderRadius: '8px',
        fontSize: '14px',
        fontWeight: '500',
        cursor: 'pointer',
        transition: 'all 0.2s ease'
    },
    vendorCard: {
        background: 'white',
        borderRadius: '12px',
        boxShadow: '0 2px 8px rgba(0,0,0,0.06)',
        border: '1px solid #f0f0f0',
        marginBottom: '12px',
        overflow: 'hidden',
        transition: 'all 0.3s ease'
    },
    vendorHeader: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        padding: '16px 24px',
        cursor: 'pointer',
        transition: 'all 0.2s ease',
        borderBottom: '1px solid transparent'
    },
    vendorInfo: {
        display: 'flex',
        alignItems: 'center',
        gap: '16px'
    },
    vendorName: {
        fontSize: '16px',
        fontWeight: '600',
        color: '#1e293b'
    },
    vendorId: {
        fontSize: '13px',
        color: '#94a3b8'
    },
    vendorTotal: {
        fontSize: '18px',
        fontWeight: '700',
        color: '#e66d33'
    },
    expandedContent: {
        padding: '0 24px 24px 24px',
        background: '#fafbfc',
        borderTop: '1px solid #f0f0f0'
    },
    moduleGrid: {
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fill, minmax(200px, 1fr))',
        gap: '10px',
        marginTop: '16px'
    },
    moduleCard: {
        background: 'white',
        borderRadius: '8px',
        padding: '12px 16px',
        border: '1px solid #e8ecf0',
        display: 'flex',
        flexDirection: 'column',
        transition: 'all 0.2s ease'
    },
    moduleName: {
        fontSize: '13px',
        fontWeight: '500',
        color: '#1e293b'
    },
    moduleCategory: {
        fontSize: '11px',
        color: '#94a3b8',
        marginTop: '4px'
    },
    categoryBadge: {
        display: 'inline-block',
        padding: '2px 10px',
        borderRadius: '12px',
        fontSize: '10px',
        fontWeight: '600',
        marginTop: '6px'
    },
    historyTable: {
        width: '100%',
        borderCollapse: 'collapse',
        marginTop: '16px',
        fontSize: '14px'
    },
    th: {
        textAlign: 'left',
        padding: '12px 16px',
        background: '#f1f5f9',
        color: '#475569',
        fontWeight: '600',
        borderBottom: '2px solid #e2e8f0'
    },
    td: {
        padding: '12px 16px',
        borderBottom: '1px solid #e8ecf0',
        color: '#334155'
    },
    modalOverlay: {
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        background: 'rgba(0,0,0,0.5)',
        backdropFilter: 'blur(4px)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        zIndex: 1000,
        padding: '20px'
    },
    modalContent: {
        background: 'white',
        borderRadius: '16px',
        padding: '32px',
        maxWidth: '480px',
        width: '100%',
        boxShadow: '0 20px 60px rgba(0,0,0,0.3)'
    },
    modalHeader: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        marginBottom: '24px'
    },
    modalTitle: {
        fontSize: '20px',
        fontWeight: '700',
        color: '#1e293b'
    },
    modalClose: {
        background: 'none',
        border: 'none',
        fontSize: '24px',
        cursor: 'pointer',
        color: '#94a3b8',
        padding: '4px'
    },
    modalBody: {
        display: 'flex',
        flexDirection: 'column',
        gap: '16px'
    },
    dateInputGroup: {
        display: 'flex',
        flexDirection: 'column',
        gap: '6px'
    },
    dateLabel: {
        fontSize: '13px',
        fontWeight: '500',
        color: '#475569'
    },
    dateInput: {
        padding: '10px 14px',
        border: '1px solid #e2e8f0',
        borderRadius: '8px',
        fontSize: '14px',
        outline: 'none',
        transition: 'all 0.2s ease',
        color: '#334155'
    },
    applyBtn: {
        padding: '12px',
        background: '#e66d33',
        color: 'white',
        border: 'none',
        borderRadius: '8px',
        fontSize: '16px',
        fontWeight: '600',
        cursor: 'pointer',
        transition: 'all 0.2s ease',
        marginTop: '8px'
    },
    dropdown: {
        position: 'absolute',
        top: 'calc(100% + 4px)',
        left: 0,
        background: 'white',
        border: '1px solid #e2e8f0',
        borderRadius: '12px',
        boxShadow: '0 10px 30px rgba(0,0,0,0.15)',
        minWidth: '160px',
        overflow: 'hidden',
        zIndex: 100
    },
    dropdownItem: {
        padding: '10px 18px',
        fontSize: '14px',
        cursor: 'pointer',
        transition: 'all 0.15s ease',
        color: '#334155'
    },
    emptyState: {
        textAlign: 'center',
        padding: '40px 20px',
        color: '#94a3b8'
    },
    totalRow: {
        background: '#f8fafc',
        fontWeight: '700',
        borderTop: '2px solid #e2e8f0'
    },
    loadingOverlay: {
        textAlign: 'center',
        padding: '40px 20px',
        color: '#64748b'
    },
    planBadge: {
        display: 'inline-block',
        padding: '4px 14px',
        borderRadius: '20px',
        fontSize: '12px',
        fontWeight: '600'
    },
    statusBadge: {
        display: 'inline-block',
        padding: '4px 14px',
        borderRadius: '20px',
        fontSize: '12px',
        fontWeight: '600'
    }
};

// ============================================
// COMPONENT
// ============================================
const SubscriptionSettlemenst = () => {
    const [subscriptions, setSubscriptions] = useState([]);
    const [filteredData, setFilteredData] = useState([]);
    const [expandedVendor, setExpandedVendor] = useState(null);
    const [searchQuery, setSearchQuery] = useState('');
    const [dateFilter, setDateFilter] = useState('All');
    const [showDateDropdown, setShowDateDropdown] = useState(false);
    const [showCustomDateModal, setShowCustomDateModal] = useState(false);
    const [fromDate, setFromDate] = useState('');
    const [toDate, setToDate] = useState('');
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const dateDropdownRef = useRef(null);

    // Date filter options
    const dateOptions = ['All', 'Today', 'Yesterday', 'This Week', 'This Month', 'Custom Range'];

    // ─── Fetch Subscriptions from API ─────────────────────────────
    const fetchSubscriptions = async () => {
        try {
            setLoading(true);
            setError(null);

            const token = localStorage.getItem("authToken");
            const response = await fetch(
                "https://backend.maamaas.com/subscription/api/subscription/admin/subscriptions?businessVertical=FOOD_AND_BEVERAGES",
                {
                    method: 'GET',
                    headers: {
                        'Authorization': `Bearer ${token}`,
                        'Content-Type': 'application/json'
                    }
                }
            );

            if (!response.ok) {
                throw new Error(`Failed to fetch subscriptions: ${response.status}`);
            }

            const data = await response.json();

            // Transform data to match our format
            const transformedData = data.map(item => ({
                id: item.vendorId || item.subscriptionId,
                vendorId: item.vendorId,
                customerId: item.customerId,
                name: item.customerName || `Vendor ${item.vendorId}`,
                mobile: item.customerMobile,
                email: item.email,
                city: item.city,
                planType: item.planType,
                billingCycle: item.billingCycle,
                totalAmount: item.totalAmount || 0,
                status: item.status,
                startDate: item.startDate,
                endDate: item.endDate,
                remainingDays: item.remainingDays,
                message: item.message,
                selectedModules: item.selectedModules || [],
                // For display in expanded view
                totalSpent: item.totalAmount || 0,
                modules: item.selectedModules || []
            }));

            setSubscriptions(transformedData);
            setFilteredData(transformedData);

        } catch (err) {
            console.error("❌ Error fetching subscriptions:", err);
            setError(err.message || "Could not load subscription data.");
        } finally {
            setLoading(false);
        }
    };

    // ─── Initial Fetch ────────────────────────────────────────────
    useEffect(() => {
        fetchSubscriptions();
    }, []);

    // ─── Filter Data ──────────────────────────────────────────────
    useEffect(() => {
        let filtered = subscriptions;

        // Search filter
        if (searchQuery.trim()) {
            const query = searchQuery.toLowerCase().trim();
            filtered = filtered.filter(item =>
                (item.vendorId?.toString().includes(query)) ||
                (item.customerId?.toLowerCase().includes(query)) ||
                (item.name?.toLowerCase().includes(query)) ||
                (item.city?.toLowerCase().includes(query))
            );
        }

        // Date filter
        if (dateFilter !== 'All' && dateFilter !== 'Custom Range') {
            const today = new Date();

            filtered = filtered.filter(item => {
                const itemDate = new Date(item.startDate);

                switch (dateFilter) {
                    case 'Today':
                        return itemDate.toDateString() === today.toDateString();
                    case 'Yesterday':
                        const yesterday = new Date(today);
                        yesterday.setDate(yesterday.getDate() - 1);
                        return itemDate.toDateString() === yesterday.toDateString();
                    case 'This Week':
                        const weekStart = new Date(today);
                        weekStart.setDate(today.getDate() - today.getDay());
                        return itemDate >= weekStart;
                    case 'This Month':
                        return itemDate.getMonth() === today.getMonth() &&
                            itemDate.getFullYear() === today.getFullYear();
                    default:
                        return true;
                }
            });
        } else if (dateFilter === 'Custom Range' && fromDate && toDate) {
            const from = new Date(fromDate);
            const to = new Date(toDate);
            filtered = filtered.filter(item => {
                const itemDate = new Date(item.startDate);
                return itemDate >= from && itemDate <= to;
            });
        }

        setFilteredData(filtered);
    }, [subscriptions, searchQuery, dateFilter, fromDate, toDate]);

    // ─── Calculate Stats ─────────────────────────────────────────
    const totalVendors = filteredData.length;
    const totalSpent = filteredData.reduce((sum, item) => sum + (item.totalAmount || 0), 0);
    const totalModules = filteredData.reduce((sum, item) => sum + (item.modules?.length || 0), 0);
    const avgSpent = totalVendors > 0 ? totalSpent / totalVendors : 0;

    // ─── Toggle Expand ──────────────────────────────────────────
    const toggleExpand = (vendorId) => {
        setExpandedVendor(expandedVendor === vendorId ? null : vendorId);
    };

    // ─── Handle Date Filter Select ──────────────────────────────
    const handleDateSelect = (option) => {
        if (option === 'Custom Range') {
            setShowCustomDateModal(true);
            setShowDateDropdown(false);
        } else {
            setDateFilter(option);
            setShowDateDropdown(false);
        }
    };

    // ─── Apply Custom Range ──────────────────────────────────────
    const applyCustomRange = () => {
        if (fromDate && toDate) {
            setDateFilter('Custom Range');
            setShowCustomDateModal(false);
        }
    };

    // ─── Format Currency ─────────────────────────────────────────
    const formatCurrency = (amount) => {
        return new Intl.NumberFormat('en-IN', {
            style: 'currency',
            currency: 'INR',
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
        }).format(amount || 0);
    };

    // ─── Get Date Filter Display Text ───────────────────────────
    const getDateFilterDisplay = () => {
        if (dateFilter === 'Custom Range' && fromDate && toDate) {
            return `${fromDate} to ${toDate}`;
        }
        return dateFilter;
    };

    // ─── Get Category Color ──────────────────────────────────────
    const getCategoryColor = (category) => {
        switch (category) {
            case 'BASE_PLAN': return { bg: '#dbeafe', color: '#1e40af' };
            case 'ORDER_TYPE': return { bg: '#d1fae5', color: '#065f46' };
            case 'FEATURE_ADD_ON': return { bg: '#fef3c7', color: '#92400e' };
            default: return { bg: '#f1f5f9', color: '#475569' };
        }
    };

    // ─── Get Status Color ────────────────────────────────────────
    const getStatusColor = (status) => {
        switch (status?.toUpperCase()) {
            case 'ACTIVE': return { bg: '#dcfce7', color: '#166534' };
            case 'EXPIRED': return { bg: '#fee2e2', color: '#991b1b' };
            case 'CANCELLED': return { bg: '#fef3c7', color: '#92400e' };
            default: return { bg: '#f1f5f9', color: '#475569' };
        }
    };

    // ─── Get Plan Type Color ─────────────────────────────────────
    const getPlanColor = (plan) => {
        switch (plan?.toUpperCase()) {
            case 'PREMIUM': return { bg: '#fef3c7', color: '#92400e' };
            case 'STANDARD': return { bg: '#dbeafe', color: '#1e40af' };
            case 'BASIC': return { bg: '#d1fae5', color: '#065f46' };
            default: return { bg: '#f1f5f9', color: '#475569' };
        }
    };

    return (
        <div style={styles.container}>
            {/* ─── Dashboard Stats ────────────────────────────────── */}
            <div style={styles.statsGrid}>
                <div style={styles.statCard}>
                    <div style={styles.statLabel}>Total Vendors</div>
                    <div style={styles.statValue}>{totalVendors}</div>
                    <div style={styles.statSub}>Active subscriptions</div>
                </div>
                <div style={styles.statCard}>
                    <div style={styles.statLabel}>Total Revenue</div>
                    <div style={styles.statValue}>{formatCurrency(totalSpent)}</div>
                    <div style={styles.statSub}>From all subscriptions</div>
                </div>
                <div style={styles.statCard}>
                    <div style={styles.statLabel}>Total Modules</div>
                    <div style={styles.statValue}>{totalModules}</div>
                    <div style={styles.statSub}>Modules purchased</div>
                </div>
                <div style={styles.statCard}>
                    <div style={styles.statLabel}>Average Spend</div>
                    <div style={styles.statValue}>
                        {totalVendors > 0 ? formatCurrency(avgSpent) : '₹0.00'}
                    </div>
                    <div style={styles.statSub}>Per vendor average</div>
                </div>
            </div>

            {/* ─── Filters Bar ────────────────────────────────────── */}
            <div style={styles.filtersBar}>
                {/* Search */}
                <div style={styles.searchWrapper}>
                    <FaSearch color="#94a3b8" size={16} />
                    <input
                        type="text"
                        style={styles.searchInput}
                        placeholder="Search by Vendor ID, Name, City..."
                        value={searchQuery}
                        onChange={(e) => setSearchQuery(e.target.value)}
                    />
                </div>

                {/* Date Filter */}
                <div style={{ position: 'relative' }} ref={dateDropdownRef}>
                    <button
                        style={styles.dateFilterBtn}
                        onClick={() => setShowDateDropdown(!showDateDropdown)}
                    >
                        <FaCalendar color="#e66d33" />
                        <span>{getDateFilterDisplay()}</span>
                        <FaChevronDown size={12} color="#94a3b8" />
                    </button>

                    {showDateDropdown && (
                        <div style={styles.dropdown}>
                            {dateOptions.map(option => (
                                <div
                                    key={option}
                                    style={{
                                        ...styles.dropdownItem,
                                        background: dateFilter === option ? '#fef3e8' : 'white',
                                        color: dateFilter === option ? '#e66d33' : '#334155'
                                    }}
                                    onClick={() => handleDateSelect(option)}
                                    onMouseEnter={(e) => e.target.style.background = '#f8fafc'}
                                    onMouseLeave={(e) => {
                                        if (dateFilter !== option) {
                                            e.target.style.background = 'white';
                                        }
                                    }}
                                >
                                    {option}
                                </div>
                            ))}
                        </div>
                    )}
                </div>

                {/* Action Buttons */}
                <button
                    style={{
                        ...styles.actionBtn,
                        background: '#f1f5f9',
                        color: '#475569'
                    }}
                    onClick={() => {
                        setSearchQuery('');
                        setDateFilter('All');
                        setFromDate('');
                        setToDate('');
                        fetchSubscriptions();
                    }}
                >
                    <FaSync size={14} /> Refresh
                </button>

                <button
                    style={{
                        ...styles.actionBtn,
                        background: '#e66d33',
                        color: 'white'
                    }}
                    onClick={() => alert('Exporting subscription data...')}
                >
                    <FaFileExport size={14} /> Export
                </button>
            </div>

            <div style={{maxHeight:"60vh", overflow:"auto", scrollbarWidth:"thin"}}>
                {/* ─── Loading State ──────────────────────────────────── */}
                {loading ? (
                    <div style={styles.loadingOverlay}>
                        <FaSpinner style={{ animation: 'spin 1s linear infinite' }} size={28} color="#e66d33" />
                        <p style={{ marginTop: '12px', fontWeight: '500' }}>Loading subscription data...</p>
                        <style>{`@keyframes spin { to { transform: rotate(360deg); } }`}</style>
                    </div>
                ) : error ? (
                    <div style={styles.emptyState}>
                        <p style={{ color: '#dc2626', fontWeight: '600' }}>⚠️ {error}</p>
                        <button
                            onClick={fetchSubscriptions}
                            style={{ ...styles.actionBtn, background: '#e66d33', color: 'white', marginTop: '12px' }}
                        >
                            Try Again
                        </button>
                    </div>
                ) : filteredData.length === 0 ? (
                    <div style={styles.emptyState}>
                        <p>No subscriptions found matching the current filters.</p>
                    </div>
                ) : (
                    /* ─── Vendor List ────────────────────────────────────── */
                    filteredData.map((vendor) => (
                        <div key={vendor.id || vendor.vendorId} style={styles.vendorCard}>
                            {/* Vendor Header */}
                            <div
                                style={{
                                    ...styles.vendorHeader,
                                    borderBottom: expandedVendor === vendor.id ? '1px solid #f0f0f0' : '1px solid transparent',
                                    background: expandedVendor === vendor.id ? '#fafbfc' : 'white'
                                }}
                                onClick={() => toggleExpand(vendor.id)}
                            >
                                <div style={styles.vendorInfo}>
                                    <div>
                                        <div style={styles.vendorName}>{vendor.name}</div>
                                        <div style={styles.vendorId}>
                                            ID: {vendor.vendorId || vendor.customerId} • {vendor.city || 'N/A'}
                                        </div>
                                    </div>
                                </div>
                                <div style={{ display: 'flex', alignItems: 'center', gap: '20px' }}>
                                    <div style={{ textAlign: 'right' }}>
                                        <div style={styles.vendorTotal}>{formatCurrency(vendor.totalAmount)}</div>
                                        <div style={{ fontSize: '12px', color: '#94a3b8' }}>Total Spent</div>
                                    </div>
                                    {expandedVendor === vendor.id ? (
                                        <FaChevronUp color="#94a3b8" />
                                    ) : (
                                        <FaChevronDown color="#94a3b8" />
                                    )}
                                </div>
                            </div>

                            {/* Expanded Content */}
                            {expandedVendor === vendor.id && (
                                <div style={styles.expandedContent}>
                                    {/* Subscription Details */}
                                    <div style={{
                                        display: 'grid',
                                        gridTemplateColumns: 'repeat(auto-fill, minmax(200px, 1fr))',
                                        gap: '12px',
                                        marginTop: '16px',
                                        padding: '16px',
                                        background: 'white',
                                        borderRadius: '10px',
                                        border: '1px solid #e8ecf0'
                                    }}>
                                        <div>
                                            <div style={{ fontSize: '12px', color: '#94a3b8' }}>Plan Type</div>
                                            <div style={{
                                                ...styles.planBadge,
                                                ...getPlanColor(vendor.planType)
                                            }}>
                                                {vendor.planType || 'N/A'}
                                            </div>
                                        </div>
                                        <div>
                                            <div style={{ fontSize: '12px', color: '#94a3b8' }}>Billing Cycle</div>
                                            <div style={{ fontWeight: '500', color: '#1e293b' }}>
                                                {vendor.billingCycle || 'N/A'}
                                            </div>
                                        </div>
                                        <div>
                                            <div style={{ fontSize: '12px', color: '#94a3b8' }}>Status</div>
                                            <div style={{
                                                ...styles.statusBadge,
                                                ...getStatusColor(vendor.status)
                                            }}>
                                                {vendor.status || 'N/A'}
                                            </div>
                                        </div>
                                        <div>
                                            <div style={{ fontSize: '12px', color: '#94a3b8' }}>Remaining Days</div>
                                            <div style={{ fontWeight: '500', color: '#1e293b' }}>
                                                {vendor.remainingDays || 'N/A'}
                                            </div>
                                        </div>
                                        <div>
                                            <div style={{ fontSize: '12px', color: '#94a3b8' }}>Start Date</div>
                                            <div style={{ fontWeight: '500', color: '#1e293b' }}>
                                                {vendor.startDate ? new Date(vendor.startDate).toLocaleDateString('en-IN', {
                                                    day: '2-digit',
                                                    month: 'short',
                                                    year: 'numeric'
                                                }) : 'N/A'}
                                            </div>
                                        </div>
                                        <div>
                                            <div style={{ fontSize: '12px', color: '#94a3b8' }}>End Date</div>
                                            <div style={{ fontWeight: '500', color: '#1e293b' }}>
                                                {vendor.endDate ? new Date(vendor.endDate).toLocaleDateString('en-IN', {
                                                    day: '2-digit',
                                                    month: 'short',
                                                    year: 'numeric'
                                                }) : 'N/A'}
                                            </div>
                                        </div>
                                    </div>

                                    {/* Modules Section */}
                                    <div style={{
                                        padding: '16px 0 8px 0',
                                        fontSize: '15px',
                                        fontWeight: '600',
                                        color: '#1e293b',
                                        display: 'flex',
                                        alignItems: 'center',
                                        gap: '8px',
                                        marginTop: '12px'
                                    }}>
                                        <FaLayerGroup size={16} color="#e66d33" />
                                        Purchased Modules
                                        <span style={{
                                            fontSize: '13px',
                                            fontWeight: '400',
                                            color: '#94a3b8',
                                            marginLeft: '4px'
                                        }}>
                                            ({vendor.modules?.length || 0} modules)
                                        </span>
                                    </div>

                                    {!vendor.modules || vendor.modules.length === 0 ? (
                                        <div style={styles.emptyState}>
                                            <p>No modules purchased</p>
                                        </div>
                                    ) : (
                                        <div style={styles.moduleGrid}>
                                            {vendor.modules.map((module, index) => {
                                                const categoryColors = getCategoryColor(module.catageory);
                                                return (
                                                    <div key={index} style={styles.moduleCard}>
                                                        <div style={styles.moduleName}>
                                                            {module.selectedModules || module}
                                                        </div>
                                                        <div style={styles.moduleCategory}>
                                                            {module.catageory || 'N/A'}
                                                        </div>
                                                        <span style={{
                                                            ...styles.categoryBadge,
                                                            background: categoryColors.bg,
                                                            color: categoryColors.color
                                                        }}>
                                                            {module.catageory || 'N/A'}
                                                        </span>
                                                    </div>
                                                );
                                            })}
                                        </div>
                                    )}

                                    {/* Total Row */}
                                    <div style={{
                                        background: '#f8fafc',
                                        borderRadius: '10px',
                                        padding: '16px 20px',
                                        marginTop: '16px',
                                        border: '2px solid #e66d33',
                                        display: 'flex',
                                        justifyContent: 'space-between',
                                        alignItems: 'center'
                                    }}>
                                        <div style={{ fontWeight: '600', color: '#1e293b' }}>
                                            <FaMoneyBillWave color="#e66d33" style={{ marginRight: '8px' }} />
                                            Total Subscription Amount
                                        </div>
                                        <div style={{
                                            fontSize: '20px',
                                            fontWeight: '700',
                                            color: '#e66d33'
                                        }}>
                                            {formatCurrency(vendor.totalAmount)}
                                        </div>
                                    </div>
                                </div>
                            )}
                        </div>
                    ))
                )}
            </div>

            {/* ─── Custom Range Modal ─────────────────────────────── */}
            {showCustomDateModal && (
                <div style={styles.modalOverlay} onClick={() => setShowCustomDateModal(false)}>
                    <div style={styles.modalContent} onClick={(e) => e.stopPropagation()}>
                        <div style={styles.modalHeader}>
                            <h3 style={styles.modalTitle}>Select Date Range</h3>
                            <button style={styles.modalClose} onClick={() => setShowCustomDateModal(false)}>
                                <MdClose />
                            </button>
                        </div>

                        <div style={styles.modalBody}>
                            <div style={styles.dateInputGroup}>
                                <label style={styles.dateLabel}>From Date</label>
                                <input
                                    type="date"
                                    style={styles.dateInput}
                                    value={fromDate}
                                    onChange={(e) => setFromDate(e.target.value)}
                                    max={toDate || undefined}
                                />
                            </div>

                            <div style={styles.dateInputGroup}>
                                <label style={styles.dateLabel}>To Date</label>
                                <input
                                    type="date"
                                    style={styles.dateInput}
                                    value={toDate}
                                    onChange={(e) => setToDate(e.target.value)}
                                    min={fromDate || undefined}
                                />
                            </div>

                            <button
                                style={styles.applyBtn}
                                onClick={applyCustomRange}
                                disabled={!fromDate || !toDate}
                            >
                                Apply Range
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default SubscriptionSettlemenst;